import { Col, Flex, notification, Row } from "antd";

import { useEffect } from "react";
import { useSalesPipelineInfo } from "sales/queries";
import { SalesRepDashboardSalesPipelineCard } from "./sales-rep-dashboard-sales-pipeline-card/SalesRepDashboardSalesPipelineCard";
import variables from "../../../../_variables.scss";
import { SalesTargetTimePeriods } from "users/components";
import { NotesList } from "notes/components";
import { useBoundStore } from "store";

export const SalesRepDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: salesPipelineInfo,
    isSuccess,
    error,
    refetch,
  } = useSalesPipelineInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  const onSalesTargetTimePeriodChange = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify='space-between'>
        <Col span={17}>
          <SalesRepDashboardSalesPipelineCard
            loading={!isSuccess}
            salesPipelineProjects={salesPipelineInfo?.salesPipelineProjects}
            pipelineDetails={salesPipelineInfo?.pipelineDetails}
            pipelineByProjectStages={salesPipelineInfo?.pipelineByProjectStages}
          />
        </Col>
        <Col span={7}>
          <NotesList title='My Project Notes' showCard />
        </Col>
      </Row>
    </Flex>
  );
};
